import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const PrivacyPolicy: React.FC = () => {
  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 'bold' }}>
        Privacy Policy
      </Typography>
      <Typography variant="subtitle1" color="text.secondary" paragraph>
        Last Updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
      </Typography>

      <Box sx={{ mt: 4 }}>
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', mt: 4 }}>
          1. Introduction
        </Typography>
        <Typography paragraph>
          Welcome to Shua. We respect your privacy and are committed to protecting your personal data. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website and use our services.
        </Typography>

        <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', mt: 4 }}>
          2. Information We Collect
        </Typography>
        <Typography paragraph>
          We may collect, use, store, and transfer different kinds of personal data about you, including:
        </Typography>
        <ul>
          <li><Typography paragraph><strong>Identity Data:</strong> First name, last name, username, or similar identifier.</Typography></li>
          <li><Typography paragraph><strong>Contact Data:</strong> Email address and telephone numbers.</Typography></li>
          <li><Typography paragraph><strong>Profile Data:</strong> Your interests, preferences, feedback, and survey responses.</Typography></li>
          <li><Typography paragraph><strong>Technical Data:</strong> Internet protocol (IP) address, your login data, browser type and version, time zone setting and location, and other technology on the devices you use to access this website.</Typography></li>
        </ul>

        <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', mt: 4 }}>
          3. How We Use Your Information
        </Typography>
        <Typography paragraph>
          We will only use your personal data when the law allows us to. Most commonly, we will use your personal data in the following circumstances:
        </Typography>
        <ul>
          <li><Typography paragraph>To register you as a new user.</Typography></li>
          <li><Typography paragraph>To manage our relationship with you.</Typography></li>
          <li><Typography paragraph>To enable you to partake in events, chats, and community features.</Typography></li>
          <li><Typography paragraph>To improve our website, products/services, marketing, or customer relationships.</Typography></li>
        </ul>

        <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', mt: 4 }}>
          4. Data Security
        </Typography>
        <Typography paragraph>
          We have put in place appropriate security measures to prevent your personal data from being accidentally lost, used, or accessed in an unauthorized way, altered, or disclosed.
        </Typography>

        <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', mt: 4 }}>
          5. Your Legal Rights
        </Typography>
        <Typography paragraph>
          Under certain circumstances, you have rights under data protection laws in relation to your personal data, including the right to request access, correction, erasure, restriction, transfer, or to object to processing.
        </Typography>

        <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', mt: 4 }}>
          6. Contact Us
        </Typography>
        <Typography paragraph>
          If you have any questions about this Privacy Policy or our privacy practices, please contact us at support@shua.com.
        </Typography>
      </Box>
    </Container>
  );
};

export default PrivacyPolicy;
